import { defineComponent as f, ref as w, watch as d, openBlock as r, createElementBlock as u, normalizeClass as c, createElementVNode as p, withModifiers as b, createVNode as m, unref as v, createBlock as h, withCtx as i, renderSlot as s, createCommentVNode as C } from "vue";
import { d as y } from "./ArrowIcon.GDkXwpPs.js";
import "./DownloadIcon.DHCHRETy.js";
import { _ as g } from "./BaseAccordionContent.vue_vue_type_script_setup_true_lang.8ErZghvk.js";
import { _ as O } from "./BaseAccordionBtn.vue_vue_type_script_setup_true_lang.0xIiFb9q.js";
const B = { key: 0 }, E = ["id", "data-cy", "aria-expanded", "aria-controls"], A = ["itemprop", "innerHTML"], I = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "BaseAccordionItem",
  props: {
    title: {},
    id: {},
    active: { type: Boolean, default: !1 },
    arrowWidth: { default: 12 },
    onContainerClickExpand: { type: Boolean, default: !1 }
  },
  emits: ["click", "accordionOpened", "accordionClosed", "update:accordionState"],
  setup(k, { emit: $ }) {
    const t = $, e = w(!1), n = k;
    d(e, (o) => {
      t(o ? "accordionOpened" : "accordionClosed", n), t("update:accordionState", o), e.value = o;
    }), d(
      () => n.active,
      (o) => {
        e.value = o;
      },
      { immediate: !0 }
    );
    const a = () => {
      e.value = !e.value;
    };
    return (o, l) => (r(), u("div", {
      class: c(o.$attrs["root-classes"])
    }, [
      !o.$slots.custom_content && !o.$slots.custom_btn && !o.$slots.custom_accordion ? (r(), u("div", B, [
        p("button", {
          id: `accordion-title-${o.id}`,
          type: "button",
          class: c(["uikit-flex uikit-w-full uikit-items-center uikit-justify-between uikit-border-0 uikit-bg-white uikit-px-5 uikit-py-4 uikit-text-left uikit-font-semibold uikit-transition-colors active:max-sm:uikit-bg-w-cultured hover:sm:uikit-bg-w-cultured", o.$attrs["btn-classes"]]),
          "data-cy": o.$attrs["data-cy"],
          "aria-expanded": e.value,
          "aria-controls": `accordion-text-${o.id}`,
          onClick: l[0] || (l[0] = b((M) => {
            a(), t("click");
          }, ["prevent", "stop"]))
        }, [
          p("span", {
            itemprop: o.$attrs.itemprop,
            innerHTML: o.title
          }, null, 8, A),
          m(v(y), {
            class: c([
              "uikit-flex-shrink-0 uikit-transition-transform motion-reduce:uikit-transition-none",
              [
                e.value ? "uikit-rotate-180" : "",
                o.$attrs["arrow-classes"]
              ]
            ]),
            "arrow-classes": o.$attrs["arrow-classes"],
            width: o.arrowWidth,
            height: o.arrowWidth
          }, null, 8, ["class", "arrow-classes", "width", "height"])
        ], 10, E)
      ])) : (o.$slots.custom_content || o.$slots.custom_btn) && !o.$slots.custom_accordion ? (r(), h(O, {
        key: 1,
        id: o.id,
        "btn-wrapper-classes": o.$attrs["btn-wrapper-classes"],
        "btn-classes": o.$attrs["btn-classes"],
        "arrow-classes": o.$attrs["arrow-classes"],
        "toggle-accordion": a,
        "on-container-click-expand": o.onContainerClickExpand,
        "accordion-open": e.value
      }, {
        custom_content: i(() => [
          s(o.$slots, "custom_content")
        ]),
        custom_btn: i(() => [
          s(o.$slots, "custom_btn", {
            btnId: `btn-${o.id}`,
            isOpen: e.value,
            toggleAccordion: a
          })
        ]),
        _: 3
      }, 8, ["id", "btn-wrapper-classes", "btn-classes", "arrow-classes", "on-container-click-expand", "accordion-open"])) : C("", !0),
      s(o.$slots, "custom_accordion", {
        id: o.id,
        isOpen: e.value,
        toggleAccordion: a
      }, () => [
        m(g, {
          id: o.id,
          "accordion-open": e.value,
          "accordion-open-classes": o.$attrs["accordion-open-classes"],
          "accordion-close-classes": o.$attrs["accordion-close-classes"],
          "accordion-classes": o.$attrs["accordion-classes"]
        }, {
          custom_accordion_content: i(() => [
            s(o.$slots, "custom_accordion_content", { isOpen: e.value })
          ]),
          default: i(() => [
            s(o.$slots, "default", { isOpen: e.value })
          ]),
          _: 3
        }, 8, ["id", "accordion-open", "accordion-open-classes", "accordion-close-classes", "accordion-classes"])
      ])
    ], 2));
  }
});
export {
  I as _
};
